import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { RootStateCampanha } from '../../../../../store/campanhaReducer';
import { formatToBRL, formatToPercentage } from 'base/src/utils/mathUtil';
import * as S from '../styles';

const connector = connectUtil(
  (state: RootStateCampanha) => ({
    resumo: state.CampanhaProdutosReducer.byResumoCampanha,
  }),
  {}
);

export interface TabResumoProps extends PropsFromRedux<typeof connector> { }

function TabResumo({ resumo }: TabResumoProps) {
  if (!resumo || Object.keys(resumo).length === 0) {
    return (
      <div style={{ padding: '20px 0' }}>
        <S.Text>Nenhum resumo disponível</S.Text>
      </div>
    );
  }

  return (
    <S.ExtratoContainer>
      <S.ExtratoHeader>
        <S.ExtratoTitle>Resumo da Campanha</S.ExtratoTitle>
        <S.ExtratoDescription>
          Informações consolidadas do participante na campanha
        </S.ExtratoDescription>
      </S.ExtratoHeader>

      <S.ResumoGrid>
        <S.ResumoCard>
          <S.ResumoCardIcon>📦</S.ResumoCardIcon>
          <S.ResumoCardContent>
            <S.ResumoCardLabel>Total Produtos Vendidos</S.ResumoCardLabel>
            <S.ResumoCardValue>{resumo.TotalProdutosVendidos}</S.ResumoCardValue>
          </S.ResumoCardContent>
        </S.ResumoCard>

        <S.ResumoCard>
          <S.ResumoCardIcon>⭐</S.ResumoCardIcon>
          <S.ResumoCardContent>
            <S.ResumoCardLabel>Total Pontos Acumulados</S.ResumoCardLabel>
            <S.ResumoCardValue isHighlight>
              {Math.round(resumo.TotalPontosAcumulados)} pts
            </S.ResumoCardValue>
          </S.ResumoCardContent>
        </S.ResumoCard>

        <S.ResumoCard>
          <S.ResumoCardIcon>🔄</S.ResumoCardIcon>
          <S.ResumoCardContent>
            <S.ResumoCardLabel>Taxa de Conversão</S.ResumoCardLabel>
            <S.ResumoCardValue>{formatToPercentage(resumo.TaxaConversaoWebGold)}</S.ResumoCardValue>
          </S.ResumoCardContent>
        </S.ResumoCard>

        <S.ResumoCard>
          <S.ResumoCardIcon>💵</S.ResumoCardIcon>
          <S.ResumoCardContent>
            <S.ResumoCardLabel>WebGold Total Campanha</S.ResumoCardLabel>
            <S.ResumoCardValue>
              {formatToBRL(resumo.WebgoldTotalCampanha)}
            </S.ResumoCardValue>
          </S.ResumoCardContent>
        </S.ResumoCard>

        <S.ResumoCard>
          <S.ResumoCardIcon>🎯</S.ResumoCardIcon>
          <S.ResumoCardContent>
            <S.ResumoCardLabel>Resgate Atual</S.ResumoCardLabel>
            <S.ResumoCardValue>{formatToBRL(resumo.TotalResgatesCampanha)}</S.ResumoCardValue>
          </S.ResumoCardContent>
        </S.ResumoCard>

        <S.ResumoCard>
          <S.ResumoCardIcon>📊</S.ResumoCardIcon>
          <S.ResumoCardContent>
            <S.ResumoCardLabel>Resgates Anteriores</S.ResumoCardLabel>
            <S.ResumoCardValue>{formatToBRL(resumo.TotalResgatgesAnteriores)}</S.ResumoCardValue>
          </S.ResumoCardContent>
        </S.ResumoCard>

        <S.ResumoCard>
          <S.ResumoCardIcon>💰</S.ResumoCardIcon>
          <S.ResumoCardContent>
            <S.ResumoCardLabel>Saldo WebGold</S.ResumoCardLabel>
            <S.ResumoCardValue>
              {formatToBRL(resumo.SaldoWebGold)}
            </S.ResumoCardValue>
          </S.ResumoCardContent>
        </S.ResumoCard>
      </S.ResumoGrid>
    </S.ExtratoContainer>
  );
}

export default connector(TabResumo);
